// Helfer für Module: `export default defineMeta({...})` in meta.ts und
// `export default defineModule({ people: {...}, admin: {...}, ai: {...} })` in module.tsx.
import type { ModuleContributions, ModuleMeta } from './types';

export function defineMeta(meta: ModuleMeta): ModuleMeta {
  return meta;
}

export function defineModule(contributions: ModuleContributions): ModuleContributions {
  return contributions;
}
